import {Button, Divider, Stack, Typography} from '@mui/material';
import {PhonesDrawer} from 'presentation/components/PhonesDrawer';
import {PhonesMenu} from 'presentation/components/PhonesMenu';
import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages/private';
import {translations} from 'presentation/translations-new';
import React, {useState} from 'react';
import {PhoneChannelsSection} from '../PhoneChannelsSection';

const {call} = translations['pt-br'].commons;
const {choosePhoneNumber} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;
const {needHelpPageDescription} = translations['pt-br'].publicFlow.forgotPassword;
export function NeedHelpPage() {
	const [openPhoneDrawerState, setOpenPhoneDrawerState] = useState<boolean>(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const {isMobile} = useMediaQueries();

	const handleOpenPhoneMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		setOpenPhoneDrawerState(true);
		setAnchorEl(event.currentTarget);
	};

	const handleClosePhoneMenu = () => {
		setOpenPhoneDrawerState(false);
		setAnchorEl(null);
	};

	const handleTogglePhoneDrawer = () => {
		setOpenPhoneDrawerState(prev => !prev);
	};

	return (
		<Stack gap={2}>
			<Typography>{needHelpPageDescription}</Typography>
			<Divider />
			<Button
				variant={'outlined'}
				size="large"
				endIcon={<Icon name="phone-filled" />}
				onClick={handleOpenPhoneMenu}>
				{call}
			</Button>
			{isMobile && openPhoneDrawerState ? (
				<PhonesDrawer.Root
					open={openPhoneDrawerState}
					toggleDrawer={handleTogglePhoneDrawer}
					title={choosePhoneNumber}>
					<PhoneChannelsSection />
				</PhonesDrawer.Root>
			) : null}
			{!isMobile && openPhoneDrawerState ? (
				<PhonesMenu.Root
					open={openPhoneDrawerState}
					onClose={handleClosePhoneMenu}
					anchorEl={anchorEl}>
					<PhoneChannelsSection />
				</PhonesMenu.Root>
			) : null}
		</Stack>
	);
}
